import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
// icons
import {
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Link,
  Snackbar,
  Stack,
  TextField,
  useTheme,
} from "@mui/material"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TablePagination from "@mui/material/TablePagination"
import TableRow from "@mui/material/TableRow"
import TableSortLabel from "@mui/material/TableSortLabel"
import Typography from "@mui/material/Typography"
// @mui
import { visuallyHidden } from "@mui/utils"
import * as React from "react"
import { useEffect, useState } from "react"
import CopyToClipboard from "../../components/CopyToClipboard"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import { useAppSelector } from "../../store"
import {
  generateReferralCode,
  generateReferralLink,
} from "../../utils/referralUtils"
import { SEO } from "../../components/SEO"
import { PATHS } from "../../constants/paths"
import useMediaQuery from "@mui/material/useMediaQuery"
import { ethers } from "ethers"
import { getDecimals, getVaultContract } from "../../data/smart"
import { handleWithdrawReferral } from "../../api/web3/handleWithdrawReferral"
import { getReferralStats } from "../../api/referralApi"
import { SuccessDialog } from "../../components/dialog/SuccessDialog"
import { useDialog } from "../../context/DialogContext"
import { ErrorDialog } from "../../components/dialog/ErrorDialog"
import LoadingButton from "@mui/lab/LoadingButton"

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === "ask"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

const headCells = [
  {
    id: "date",
    label: "Date",
  },
  {
    id: "type",
    label: "Type",
  },
  {
    id: "source",
    label: "Source",
  },
  {
    id: "amount",
    label: "Amount",
  },
  {
    id: "status",
    label: "Status / TX Hash",
  },
]

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }

  return (
    <TableHead sx={{ overflow: "hidden" }}>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? "right" : "left"}
            align={headCell.numeric ? "right" : "center"}
            // padding={headCell.disablePadding ? "none" : "normal"}
            padding={"none"}
            sx={{ py: 1, px: 0 }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export const ReferalPage = () => {
  const theme = useTheme()
  const { user } = useAppSelector((state) => state.user)

  const [rows, setRows] = useState([])
  const [referralStats, setReferralStats] = useState({
    referralCount: 0,
    totalEarned: 0,
    availableToWithdraw: 0,
    withdrawnTotal: 0,
  })
  const [loading, setLoading] = useState(false)

  const [order, setOrder] = useState("ask")
  const [orderBy, setOrderBy] = useState("id")
  const [selected, setSelected] = useState([])
  const [page, setPage] = useState(0)
  const [dense, setDense] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  // Состояние для диалогового окна подтверждения
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const [withdrawAmount, setWithdrawAmount] = useState("")

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc"
    setOrder(isAsc ? "desc" : "asc")
    setOrderBy(property)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const isSelected = (id) => selected.indexOf(id) !== -1

  // Обработчик нажатия на кнопку Withdraw
  const handleWithdrawClick = () => {
    setConfirmDialogOpen(true)
  }

  const [openSuccessDialog, closeSuccessDialog] = useDialog()
  const [openErrorDialog, closeErrorDialog] = useDialog()

  // Обработчик подтверждения операции (кнопка Yes)
  const handleConfirmWithdraw = async () => {
    setConfirmDialogOpen(false)
    setLoading(true)
    try {
      await handleWithdrawReferral(user, withdrawAmount)
      await loadReferralStats()
      openSuccessDialog({
        children: (
          <SuccessDialog
            message={"Withdrawal successful"}
            closeDialog={closeSuccessDialog}
          />
        ),
      })
      setWithdrawAmount("")
    } catch (e) {
      openErrorDialog({
        children: (
          <ErrorDialog
            message={e?.message || String(e)}
            closeDialog={closeErrorDialog}
          />
        ),
      })
    } finally {
      setLoading(false)
    }
  }

  // Обработчик отмены операции (кнопка No)
  const handleCancelWithdraw = () => {
    setConfirmDialogOpen(false)
  }

  // Загрузка статистики рефералов при монтировании компонента
  useEffect(() => {
    if (user.address) {
      loadReferralStats()
    }
  }, [user.address])

  const loadReferralStats = async () => {
    setLoading(true)
    try {
      const statsApi = await getReferralStats(
        generateReferralCode(user.address),
        user.sessionToken,
      )
      if (statsApi.success) {
        referralStats.referralCount = statsApi.referralCount
      }

      const vaultContract = await getVaultContract()
      const stats = await vaultContract.referrals(user.address)
      const decimals = await getDecimals()

      referralStats.totalEarned = ethers.utils.formatUnits(
        stats[2],
        decimals,
      )
      referralStats.withdrawnTotal = ethers.utils.formatUnits(
        stats[1],
        decimals,
      )
      referralStats.availableToWithdraw = ethers.utils.formatUnits(
        stats[0],
        decimals,
      )
    } catch (error) {
      console.error("Error loading referral stats:", error)
    } finally {
      setLoading(false)
    }
  }

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0

  // Генерируем реферальную ссылку
  const referralLink = user.address ? generateReferralLink(user.address) : ""

  const [openSnack, setOpenSnack] = useState(false)

  const isDownSm = useMediaQuery("(max-width: 600px)")

  const handleCopy = () => {
    navigator.clipboard
      .writeText(referralLink)
      .then(() => setOpenSnack(true))
      .catch((err) => {
        console.error("Не удалось скопировать текст: ", err)
      })
  }

  const withdrawMinAmount = 0.00001

  return (
    <Box>
      <SEO
        title="Zombie TD | Referral Program - Earn with Friends"
        description="Invite friends to Zombie TD and earn rewards through our referral program."
        ogTitle="Zombie TD | Referral Program"
        ogDescription="Share your referral link, invite friends, and earn USDT."
        ogUrl={PATHS.REFERAL.PATH}
      />
      <Box sx={{ width: "100%" }}>
        <Box id="gun-of-the-game">
          <Typography variant="h1" mb={{ xs: 0, sm: 2 }}>
            Referrals
          </Typography>
          <Typography gutterBottom>
            Invite friends and earn rewards in USDT when they participate in FCD
            and NFT Box sales.
            <br />
            You earn:
            <br />
            <Stack spacing={1} sx={{ pl: 5 }}>
              <ul className="customList">
                <li>8% of your referral's FCD investment in Round 1</li>
                <li>10% of your referral's FCD investment in Round 2</li>
                <li>12% of your referral's FCD investment in Round 3</li>
                <li>
                  15% of all NFT Box purchases (Commanders and Turrets) made by
                  your referrals
                </li>
              </ul>
            </Stack>
            All rewards are paid directly in USDT.
          </Typography>
        </Box>

        <Grid mt={{ xs: 0, sm: 4 }} id="gun-of-the-game" container>
          {/* Блок 1: Referral Link */}
          <Grid xs={12} lg={4} mt={2} item>
            <Typography variant="h3">Your Referral Link</Typography>
            <Typography gutterBottom>
              Share your personal link to start earning rewards.
            </Typography>

            <Stack direction={{ xs: "column", sm: "row" }}>
              <Typography variant="body1" component="span">
                Referral Link:{" "}
              </Typography>

              <Stack direction="row">
                <Link
                  component="button"
                  variant="body1"
                  underline="hover"
                  onClick={handleCopy}
                  sx={{
                    cursor: "pointer",
                    padding: "0 0.5rem",
                    wordBreak: "break-all",
                  }}
                >
                  {referralLink || "Connect wallet to generate link"}
                </Link>

                <CopyToClipboard>
                  {({ copy }) => (
                    <Button
                      size={"small"}
                      sx={{ minWidth: "auto" }}
                      onClick={() => copy(referralLink)}
                      disabled={!referralLink}
                    >
                      <ContentCopyIcon />
                    </Button>
                  )}
                </CopyToClipboard>
                <Snackbar
                  open={openSnack}
                  autoHideDuration={2000}
                  onClose={() => setOpenSnack(false)}
                  message="Link copied!"
                  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                />
              </Stack>
            </Stack>
          </Grid>

          {/* Блок 2: Referral Stats */}
          <Grid xs={12} lg={4} mt={2} item>
            <Typography variant="h3">Your Referral Stats</Typography>
            <Typography gutterBottom>
              <Stack spacing={1} sx={{ pl: 5 }}>
                <ul className="customList">
                  <li>
                    {" "}
                    <span className="primary">Total Earned:</span>{" "}
                    {loading
                      ? "Loading..."
                      : `${referralStats.totalEarned} USDT`}
                  </li>
                  <li>
                    {" "}
                    <span className="primary">Available to Withdraw:</span>{" "}
                    {loading
                      ? "Loading..."
                      : `${referralStats.availableToWithdraw} USDT`}
                  </li>
                  <li>
                    {" "}
                    <span className="primary">Withdrawn Total:</span>{" "}
                    {loading
                      ? "Loading..."
                      : `${referralStats.withdrawnTotal} USDT`}
                  </li>
                  <li>
                    {" "}
                    <span className="primary">Referrals Joined:</span>{" "}
                    {loading
                      ? "Loading..."
                      : `${referralStats.referralCount} users`}
                  </li>
                </ul>
                <br />
              </Stack>
            </Typography>
          </Grid>

          {/* Блок 3: Withdraw Earnings */}
          <Grid xs={12} lg={4} mt={{ xs: 0, sm: 2 }}>
            <Typography variant="h3">Withdraw Earnings</Typography>
            <Typography gutterBottom>
              Withdraw your earned USDT any time.
              <br />
              Minimum amount: {withdrawMinAmount} USDT
              <br />
              <i>Transaction fees: covered by user</i>
            </Typography>
            <Box mt={2}>
              <Typography>Amount to Withdraw:</Typography>
              <Stack spacing={2} mt={1}>
                <TextField
                  id="amount-tokens"
                  label={`Enter the amount in USDT (min. ${withdrawMinAmount} USDT)`}
                  variant="outlined"
                  size={"small"}
                  fullWidth
                  type={"number"}
                  value={withdrawAmount}
                  onChange={(e) => setWithdrawAmount(e.target.value)}
                  shrink
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    min: withdrawMinAmount,
                  }}
                  sx={{
                    maxWidth: { xs: "100%", sm: "350px" },
                  }}
                />

                <LoadingButton
                  color="primary"
                  variant={"contained"}
                  onClick={handleWithdrawClick}
                  loading={loading}
                  disabled={
                    loading ||
                    referralStats.availableToWithdraw < withdrawMinAmount
                  }
                  fullWidth
                  sx={{
                    fontFamily: "RUSBoycott, sans-serif",
                    maxWidth: { xs: "100%", sm: "350px" },
                  }}
                >
                  Withdraw
                </LoadingButton>
              </Stack>
            </Box>
          </Grid>
        </Grid>

        {/* Диалоговое окно подтверждения */}
        <Dialog
          open={confirmDialogOpen}
          onClose={handleCancelWithdraw}
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-description"
        >
          <DialogTitle id="confirm-dialog-title">
            Confirmation of the operation
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-dialog-description">
              Are you sure you want to withdraw {withdrawAmount} USDT? This
              operation cannot be canceled.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCancelWithdraw}
              color="secondary"
              variant="outlined"
            >
              No
            </Button>
            <Button
              onClick={handleConfirmWithdraw}
              color="primary"
              variant="contained"
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  )
}
